import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { preference: String }

  connect() {
    this.applyTheme(this.preferenceValue)
  }

  preferenceValueChanged() {
    this.applyTheme(this.preferenceValue)
  }

  applyTheme(theme) {
    const html = document.documentElement

    if (theme === 'dark') {
      html.classList.add('dark')
    } else {
      html.classList.remove('dark')
    }
  }
}
